/* eslint-disable no-unused-vars */
import React from "react";
import ErrorBoundaryPage from "pages/Error";
import { TrackJS } from "trackjs";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: { message: "", stack: "" },
      info: { componentStack: "" },
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    TrackJS.track(error)
    this.setState({ error, errorInfo });

    // Log error info somewhere
  }

  render() {
    const { hasError, error, errorInfo } = this.state;

    return hasError ? <ErrorBoundaryPage /> : this.props.children;
    // if (this.state.errorInfo) {
    // // const classes = useStyles();
    //   return <h2>Something went wrong!</h2>
    // }
    // return this.props.children;
  }
}

export default ErrorBoundary;
